import { Button, Descriptions, Divider, Select, Space } from "antd"
import { ItemClasses } from "../../common/constants"
import { formatPercentage } from "../BudgetCalculator/budgetCalculatorModel"
import { useBudgets, useBudgetYears } from "../Budgets/budgetQueries"
import VSpace from "../common/VSpace"
import { centsToDollarsDisplay } from "../displayFormatters"
import { calculatePricingBreakdown, CatalogItemFormValues } from "./catalogItemModel"

export type Props = {
  catalogItem: CatalogItemFormValues
  budgetYear: number
  onBudgetYearChange: (year: number) => void
}

const PricingBreakdown = ({ catalogItem, budgetYear, onBudgetYearChange }: Props) => {
  const budgetYears = useBudgetYears()
  const budgetsQuery = useBudgets()
  const budgets = budgetsQuery.data?.budgets ?? []
  if (!catalogItem) {
    return <></>
  }

  const budgetOptions = budgetYears.data?.map(x => ({
    label: x.toString(),
    value: x,
    disabled: !budgets.find(y => y.year === x && y.class === catalogItem.itemClass)
  }))

  const classBudget = budgets.find(x => x.class === catalogItem.itemClass && x.year === budgetYear)
  const pricingBreakdown = classBudget ? calculatePricingBreakdown(catalogItem, classBudget) : undefined

  const manageBudgets = () => {
    window.location.href = '/#!/setup'
  }

  return <VSpace>
    <Space>
      <span>Budget</span>
      <Select
        value={budgetYear}
        onChange={onBudgetYearChange}
        options={budgetOptions}
        popupMatchSelectWidth={false}
        popupRender={menu => (
          <div>
            {menu}
            <Divider style={{ margin: '4px 0' }} />
            <Button type="text" onClick={manageBudgets}>Manage Budgets</Button>
          </div>
        )}
      />
    </Space>
    <Descriptions column={1} bordered>
      <Descriptions.Item label="Unit Cost">{centsToDollarsDisplay(pricingBreakdown?.unitCost)}</Descriptions.Item>
      {catalogItem.itemClass === ItemClasses.Labor && <Descriptions.Item label="Adjusted Cost">{centsToDollarsDisplay(pricingBreakdown?.adjustedCost)}</Descriptions.Item>}
      <Descriptions.Item label="Tax">
        {centsToDollarsDisplay(pricingBreakdown?.tax)}
      </Descriptions.Item>
      <Descriptions.Item label={`Overhead (${formatPercentage(pricingBreakdown?.overheadPercentage ?? 0)})`}>
        {centsToDollarsDisplay(pricingBreakdown?.overhead)}
      </Descriptions.Item>
      <Descriptions.Item label="Breakeven">
        {centsToDollarsDisplay(pricingBreakdown?.breakeven)}
      </Descriptions.Item>
      <Descriptions.Item label={`Profit (${formatPercentage(pricingBreakdown?.profitMargin ?? 0)})`}>
        {centsToDollarsDisplay(pricingBreakdown?.profit)}
      </Descriptions.Item>
      <Descriptions.Item label="Unit Price">
        {centsToDollarsDisplay(pricingBreakdown?.unitPrice)}
      </Descriptions.Item>
    </Descriptions>
  </VSpace>
}

export default PricingBreakdown 
